import { erpAxios } from '.';

const getBanke = async () => {
  const { data } = await erpAxios.get('/banke');
  return data;
};

export default getBanke;
